//
// InsetOptions.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../core/RendererModel";
import "../layoutOverlay/AutoAlignPositions";
import "./InsetContentDisplay";
import "./InsetDataScheme";
import "../core/HorizontalAlignment";
import "../core/styles/TextAttributes";
import "../core/VerticalAlignment";

var InsetOptions = createModule("gtl::InsetOptions", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel","gtl::RendererModel"], EventDispatcher, [
    ,
    {
        border: 2,
        titleAttributes: 1,
        backgroundColor: 10,
        textAttributes: 1,
        hAlign: 4,
        opaque: 2,
        dataScheme: 4,
        contentDisplay: 4,
        autoAlign: 1,
        title: 7,
        separator: 7,
        vAlign: 4,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default InsetOptions;
